import { MasterButton } from "App/Component/ui";
import { removeCookie } from "App/utils/cookies";
import React from "react";
export default function ErrorFallback() {
  const handleClickClear = () => {
    removeCookie();
    window.location.reload();
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          flexDirection: "column",
          marginTop: "20%",
        }}>
        <div>
          <p>Something went wrong</p>
        </div>

        <div className='mt-1'>
          <MasterButton
            color='green'
            name='RELOAD'
            size='lg'
            type='button'
            onClick={() => handleClickClear()}
          />
        </div>
      </div>
    </>
  );
}
